import { BaseSlide } from '../../models/slides/BaseSlide';
import CustomSlideContent from '../slides/CustomSlide/CustomSlideContent';
import PackageContent from '../slides/PackageSlide/PackageContent';
import WineContent from '../slides/WineSlide/WineContent';
import EventContent from '../slides/eventSlide/EventContent';

interface CarouselSlideContent {
  slides: any[];
  currentIndex: number;
  textColor: string;
  buttonColor: string;
  buttonTextColor: string;
}

/**
 * CarouselContent component
 * this component is responsible for rendering the content of the carousel by the type of the slide
 * @param currentIndex - the current index of the carousel
 * @param buttonColor - the color of the buttons
 * @param textColor - the color of the text
 * @param buttonTextColor - the color of the button text
 * @param slides - the slides of the carousel
 * @returns The content of the carousel
 */

export const CarouselContent = ({ currentIndex, buttonColor, textColor, buttonTextColor, slides }: CarouselSlideContent) => {
  return (
    <div className='h-full' key={slides?.length}>
      {slides?.map((slide: BaseSlide, slideIndex) => (
        <div className={`${currentIndex === slideIndex ? 'h-full' : ''}`} key={slideIndex}>
          {slideIndex === currentIndex && slide.type === 'PACKAGE' && <PackageContent slides={slides} currentIndex={currentIndex} textColor={textColor} buttonColor={buttonColor} buttonTextColor={buttonTextColor} />}
          {slideIndex === currentIndex && slide.type === 'PRODUCT' && <WineContent slides={slides} currentIndex={currentIndex} textColor={textColor} buttonColor={buttonColor} buttonTextColor={buttonTextColor} />}
          {slideIndex === currentIndex && slide.type === 'CUSTOM' && <CustomSlideContent slides={slides} currentIndex={currentIndex} textColor={textColor} buttonColor={buttonColor} buttonTextColor={buttonTextColor} />}
          {slideIndex === currentIndex && slide.type === 'EVENT' && <EventContent slides={slides} currentIndex={currentIndex} textColor={textColor} buttonColor={buttonColor} buttonTextColor={buttonTextColor} />}
        </div>
      ))}
    </div>
  );
};
